import {Component, computed, input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {TranslocoDirective} from "@jsverse/transloco";
import {PillLogoComponent, Size} from 'shared-lib';

@Component({
  selector: 'app-third-page',
  imports: [
    NgOptimizedImage,
    TranslocoDirective,
    PillLogoComponent
  ],
  templateUrl: './third-page.component.html',
  styleUrl: './third-page.component.scss'
})
export class ThirdPageComponent {
  private _yearsInMs = (1000 * 60 * 60 * 24 * 365);

  companyName = input.required<string>();
  companyLogo = input.required<string>();
  firstVisit = input<Date>();
  yearsMembership = computed(() => {
    if (!this.firstVisit()) {
      return 0;
    }
    const currentDate = new Date();
    return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      - Date.UTC(this.firstVisit()!.getFullYear(), this.firstVisit()!.getMonth(), this.firstVisit()!.getDate()))
      / this._yearsInMs);
  });

  protected readonly Size = Size;
}
